import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import axios from "axios";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";
import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import { getAccessToken } from "../../helpers/authConfig";

class EventDateService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktarih/get-list`)
      .then((response) => {
        return response.data;
      });
  }

  getCompanyCalendarList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktarih/get-company-calendar-list`)
      .then((response) => {
        return response.data;
      });
  }

  getListIntra(timestamp, signature) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktarih/get-company-calendar-intra`, {
        params: {
          timestamp: timestamp,
          signature: signature,
        },
      })
      .then((response) => {
        return response.data.data;
      });
  }

  getEventDate(id) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktarih/get-by-id/${id}`)
      .then((response) => {
        return response.data;
      });
  }

  getEventDates(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinliktarih/get-list-by-filter?${toDataSourceRequestString(
          dataState
        )}`
      )
      .then((response) => {
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }

  async updateEventDate(data) {
    const token = await getAccessToken();
    return axios
      .put(`${API_GATEWAY + PR_DEP}/etkinliktarih/update`, {
        ...data,
        Token: token,
      })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async addEventDate(data) {
    const token = await getAccessToken();
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinliktarih/add`, {
        ...data,
        Token: token,
      })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  deleteEventDate(id) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinliktarih/delete/${id}`)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  getReport() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktarih/get-report`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new EventDateService();
